// Auth Types
export const CONTACT_SUBMISSION = 'CONTACT_SUBMISSION';

// Errors types
export const GET_ERRORS = 'GET_ERRORS';

